// extracted by mini-css-extract-plugin
module.exports = {"BlogDetails":"Blogdetails_BlogDetails__3mAUh","mainSection":"Blogdetails_mainSection__17aH6","RelatedLinks":"Blogdetails_RelatedLinks__1QRWX"};